import React, { useMemo } from 'react';

import { FaCheck } from 'react-icons/fa';

import { MenuItemsData } from 'pages/NewRefuel/providers';

import {
  Container,
  StepsWrapper,
  ActivesStepsWrapper,
  StepCompleted,
  StepActive,
  StepActiveIcon,
  StepIncomplete,
  TitleStepWrapper,
  Title,
  SubTitle,
  InconpleteStepWrapper,
} from './styles';

type HeaderStepsMobileProps = {
  steps: MenuItemsData[];
  activeStep: number;
};

const HeaderStepsMobile: React.FC<HeaderStepsMobileProps> = ({
  steps,
  activeStep,
}) => {
  const activeStepSelected = useMemo(() => {
    return steps.find((step) => step.step === activeStep);
  }, [steps, activeStep]);

  const stepsBefore = steps.filter((step) => step.step <= activeStep);
  const stepsAfter = steps.filter((step) => step.step > activeStep);

  return (
    <Container>
      <StepsWrapper>
        <ActivesStepsWrapper>
          {stepsBefore.map((step) => {
            if (activeStep > step.step && step.step !== activeStep) {
              return (
                <StepCompleted key={step.step}>
                  <FaCheck size={12} color="#ffff" />
                </StepCompleted>
              );
            }
            if (step.step === activeStep) {
              return (
                <StepActive key={step.step}>
                  <StepActiveIcon />
                </StepActive>
              );
            }
            return null;
          })}
        </ActivesStepsWrapper>
        <TitleStepWrapper>
          <Title>{activeStepSelected?.name}</Title>
          <SubTitle>
            {`Passo ${activeStepSelected?.step} de ${steps.length}`}
          </SubTitle>
        </TitleStepWrapper>
      </StepsWrapper>
      <InconpleteStepWrapper>
        {stepsAfter.map((step) => (
          <StepIncomplete key={step.step} />
        ))}
      </InconpleteStepWrapper>
    </Container>
  );
};

export default HeaderStepsMobile;
